import { useTrendingNiches } from "queries";
import { NicheListWidgetAlive } from "components/widgets";
import { INiche } from "services/types";
import { routes } from "routes";

export const TrendingNiches = () => {
  const niches = useTrendingNiches();

  if (niches.isError) {
    return <p>Error loading niches.</p>;
  }

  const items = niches.data ? niches.data.map((el: INiche) => ({
    id: el.id,
    name: el.name,
    image: el.thumbnail,
    subscribers: el.subscribers,
  })) : [];

  return (
    <NicheListWidgetAlive
      className="trendingNiches"
      title="🔥️ Trending Niches"
      link={routes.niches()}
      niches={items}
      page={1}
    />
  );
};
